// extracted by mini-css-extract-plugin
export default {"errors":"index_errors_f1_eZ","container":"index_container_nhCcC","footerNav":"index_footerNav_kcIJr"};